import type { ProMessages } from './types';

export const proFr: ProMessages = {
  landing: {
    eyebrow: 'Tarifs',
    standardName: 'Standard',
    standardTagline: 'Pour démarrer sans rien payer',
    standardCta: 'Commencer gratuitement',
    proName: 'Pro',
    proBadge: '0 % de frais',
    proPrice: '49,99 $',
    proPeriod: '/ mois',
    proNote: 'Sans engagement · payable en GRAM (ex-TON) ou en Telegram Stars',
    proFeatures: [
      'Connectez votre propre bot Telegram',
      '0 % de frais de transaction, sur tous vos paiements',
      'Stars encaissés directement sur votre bot (retrait Telegram dès 1 000 Stars)',
      'Vos clients paient sur votre marque (@votre_bot)',
      'Contenu, abonnements et accès canal livrés par votre bot',
      'Retraits de votre solde plateforme sans commission',
      'Support prioritaire',
    ],
    proCta: 'Passer en Pro',
    payWith: 'Paiement en GRAM (ex-TON) ou en Telegram Stars, activation automatique',
    stepsTitle: 'Votre bot connecté en 3 minutes',
    steps: [
      { title: 'Passez en Pro', desc: 'Réglez 49,99 $ en GRAM ou en Stars : la formule s’active toute seule.' },
      { title: 'Collez le token de votre bot', desc: 'Créez-le avec @BotFather et collez le token dans votre tableau de bord.' },
      { title: 'Encaissez sans commission', desc: 'Vos liens de paiement passent par votre bot : les Stars arrivent chez vous.' },
    ],
    calcTitle: 'Combien économisez-vous avec Pro ?',
    calcSalesLabel: 'Ventes mensuelles',
    calcStandard: 'Frais Standard (3 %)',
    calcPro: 'Abonnement Pro',
    calcSaving: 'Économie avec Pro',
    calcBreakEven: 'Pro est rentable dès {amount} de ventes par mois.',
    calcBelow: 'Sous {amount} de ventes par mois, la formule Standard reste la plus économique.',
    faq: [
      {
        question: 'Comment fonctionne le bot personnalisé ?',
        answer:
          'Vous créez un bot avec @BotFather et collez son token dans votre tableau de bord. Vos liens de paiement sont alors générés par votre bot : vos clients paient chez vous et la plateforme ne prélève rien.',
      },
      {
        question: 'Où arrivent mes Stars avec la formule Pro ?',
        answer:
          'Directement dans le solde Stars de votre bot sur Telegram. Ils ne transitent pas par la plateforme, donc aucune commission de 3 %. Attention : c’est Telegram qui fixe les règles de retrait des Stars d’un bot : minimum 1 000 Stars, et seulement après 21 jours d’ancienneté. En dessous de 1 000 Stars, ils restent sur le bot.',
      },
      {
        question: 'Comment payer et renouveler la formule Pro ?',
        answer:
          '49,99 $ pour 30 jours, en GRAM (ex-TON) ou en Telegram Stars. Pas de prélèvement automatique : vous renouvelez quand vous voulez et les jours restants sont cumulés.',
      },
      {
        question: 'Que se passe-t-il quand la formule Pro expire ?',
        answer:
          'Vos nouveaux liens repassent par le bot de la plateforme (3 %). Les liens déjà créés avec votre bot continuent de fonctionner pour vos clients.',
      },
    ],
    seoSuffix: 'Formule Pro : votre propre bot Telegram, 0 % de frais, 49,99 $/mois.',
  },
  app: {
    menuLabel: 'Pro',
    eyebrow: 'Formule Pro',
    title: 'Votre bot, 0 % de frais',
    subtitle: 'Connectez votre propre bot Telegram : les paiements en Stars arrivent directement chez vous, sans commission.',
    loadError: 'Impossible de charger votre formule.',
    statusFree: 'Formule Standard',
    statusActive: 'Pro actif',
    statusUntil: 'Jusqu’au {date} · {days} jours restants',
    statusExpired: 'Pro expiré le {date}',
    expiredNotice:
      'Votre formule Pro a expiré : vos nouveaux liens passent par le bot de la plateforme (3 % de frais). Renouvelez pour retrouver votre bot.',
    priceLine: '{price} $ pour {days} jours',
    upgrade: 'Passer en Pro',
    renew: 'Prolonger de {days} jours',
    benefitsTitle: 'Ce que vous débloquez',
    benefits: [
      'Votre propre bot Telegram connecté en quelques clics',
      '0 % de frais de transaction, y compris sur les retraits de la plateforme',
      'Stars encaissés directement sur votre bot',
      'Vos clients voient votre marque, pas la nôtre',
      'Livraison de contenu, abonnements et accès canal via votre bot',
    ],
    payTitle: 'Choisissez votre moyen de paiement',
    payTon: 'Payer en GRAM (ex-TON)',
    payTonSub: '≈ {amount} GRAM',
    payStars: 'Payer en Stars',
    payStarsSub: '{amount} ⭐',
    tonUnavailable: 'Paiement GRAM bientôt disponible',
    checkoutError: 'Impossible de démarrer le paiement. Réessayez dans un instant.',
    tonTitle: 'Envoyez exactement ce montant en GRAM (ex-TON)',
    tonAmountLabel: 'Montant',
    tonAddressLabel: 'Adresse',
    tonMemoLabel: 'Commentaire (obligatoire)',
    tonMemoHint: 'Sans ce commentaire, nous ne pouvons pas identifier votre paiement.',
    openWallet: 'Ouvrir dans Tonkeeper',
    scanQr: 'ou scannez ce QR code avec votre wallet',
    waiting: 'En attente du paiement… cette page se met à jour automatiquement.',
    quoteExpires: 'Montant garanti encore {time}',
    quoteExpired: 'Le cours a expiré.',
    refreshQuote: 'Actualiser le montant',
    underpaid: 'Paiement reçu mais incomplet ({amount} GRAM). Contactez le support pour le régulariser.',
    starsTitle: 'Payez dans Telegram',
    starsHint: 'Une fenêtre de paiement Telegram Stars va s’ouvrir. L’activation est immédiate.',
    starsPayNow: 'Payer {amount} ⭐',
    paid: 'Paiement reçu ! Votre formule Pro est active.',
    cancel: 'Annuler',
    copied: 'Copié',
    botTitle: 'Votre bot Telegram',
    botLocked: 'Disponible avec la formule Pro.',
    botIntro: 'Connectez le bot qui encaissera vos ventes.',
    botStep1: 'Ouvrez @BotFather et envoyez /newbot',
    botStep2: 'Copiez le token fourni (123456789:AA…)',
    botStep3: 'Collez-le ci-dessous',
    tokenLabel: 'Token du bot',
    tokenPlaceholder: '123456789:AA…',
    connect: 'Connecter mon bot',
    connecting: 'Connexion…',
    connectedTitle: 'Bot connecté',
    webhookOk: 'Connexion active',
    webhookKo: 'Connexion à réparer',
    pendingUpdates: '{count} événements en attente',
    repair: 'Réparer la connexion',
    repaired: 'Connexion rétablie.',
    disconnect: 'Déconnecter',
    disconnectConfirm: 'Déconnecter @{bot} ? Les liens déjà créés avec ce bot ne pourront plus être payés.',
    openBot: 'Ouvrir le bot',
    botConnected: 'Bot connecté : vos prochains liens passeront par @{bot}.',
    botDisconnected: 'Bot déconnecté.',
    botWarning:
      'La connexion remplace le webhook actuel de votre bot. N’utilisez pas un bot déjà branché sur un autre service.',
    botInfoTitle: 'Comment ça marche',
    botInfo: [
      'Vos nouveaux liens de paiement sont créés par votre bot.',
      'Les Stars arrivent directement dans le solde de votre bot sur Telegram : ils ne passent pas par la plateforme, donc 0 % de frais.',
      'Vous les retirez vous-même vers un wallet GRAM (ex-TON) via Fragment, depuis la section « Balance » de votre bot : Telegram impose un minimum de 1 000 Stars, une ancienneté de 21 jours et la double authentification.',
      'Le tableau de bord continue d’afficher vos ventes et la livraison de contenu fonctionne avec votre bot.',
    ],
    withdrawFeeHint: 'Brut : {gross} Stars · Frais : 0 (formule Pro) · Vous recevez : {net} Stars',
    directBadge: 'Direct (bot perso)',
    directEarned: 'Encaissé sur votre bot',
    settingsCommissionPro: '0 % (formule Pro active)',
    supportLabel: 'Un souci avec un paiement ? Écrivez-nous :',
  },
};
